import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import { updateMeta } from "../../store/actions/metaAction";
import { Col, Row, Container } from "reactstrap";
import { useForm, Controller } from "react-hook-form";
import ReactQuill from "react-quill";

const FaqsCreate = () => {
	const dispatch = useDispatch();
	const history = useHistory();

	const {
		register,
		control,
		handleSubmit,
		setValue,
		formState: { errors },
	} = useForm({
		defaultValues: {
			question: { ar: "", en: "" },
			answer: { ar: "", en: "" },
		},
	});

	useEffect(() => {
		dispatch(
			updateMeta({
				title: "اضافة سؤال جديد",
				breadcrumb: "الاسئلة الشائعة",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
	}, []);

	const onSubmit = data => {
		if (
			!data.question?.ar.trim() ||
			!data.question?.en.trim() ||
			!data.answer?.ar.trim() ||
			!data.answer?.en.trim()
		) {
			toast.error("يرجى ملء جميع الحقول باللغة العربية والإنجليزية");
			return;
		}

		axios
			.post(
				`${process.env.REACT_APP_API_URL}pages/faqs/sections`,
				{
					section: { title: "faq", ...data },
				},
				{
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
					},
				}
			)
			.then(() => {
				toast.success("تم إضافة السؤال بنجاح");
				history.push("/faqs/index");
			})
			.catch(() => toast.error("حدث خطأ!"));
	};

	const quillModules = {
		toolbar: [
			[{ header: [1, 2, false] }],
			["bold", "italic", "underline", "strike"],
			[{ align: [] }],
			[{ list: "ordered" }, { list: "bullet" }],
			["blockquote", "code-block"],
			["link", "image", "video"],
			["clean"],
		],
	};

	const quillFormats = [
		"header",
		"bold",
		"italic",
		"underline",
		"strike",
		"align",
		"list",
		"blockquote",
		"code-block",
		"direction",
		"link",
		"image",
		"video",
	];

	return (
		<section>
			<Container>
				<form onSubmit={handleSubmit(onSubmit)}>
					<div className="card">
						<div className="card-body">
							<Row style={{ marginTop: "2rem" }}>
								<Col md={6}>
									<div className="form-item">
										<label htmlFor="questionAr">السؤال باللغة العربية</label>
										<input
											id="questionAr"
											{...register("question.ar", { required: true })}
											className="form-control"
										/>
										{errors.question?.ar && (
											<small className="text-danger">هذا الحقل مطلوب</small>
										)}
									</div>
								</Col>
								<Col md={6}>
									<div className="form-item">
										<label htmlFor="questionEn">السؤال باللغة الانجليزية</label>
										<input
											id="questionEn"
											{...register("question.en", { required: true })}
											className="form-control"
										/>
										{errors.question?.en && (
											<small className="text-danger">هذا الحقل مطلوب</small>
										)}
									</div>
								</Col>
							</Row>

							<Row>
								<Col md={6}>
									<div className="form-item">
										<label htmlFor="faqAR">الإجابة باللغة العربية</label>
										<Controller
											name="answer.ar"
											control={control}
											rules={{ required: true }}
											render={({ field }) => (
												<ReactQuill
													{...field}
													id="faqAR"
													theme="snow"
													modules={quillModules}
													formats={quillFormats}
												/>
											)}
										/>
										{errors.answer?.ar && (
											<small className="text-danger">هذا الحقل مطلوب</small>
										)}
									</div>
								</Col>
								<Col md={6}>
									<div className="form-item">
										<label htmlFor="faqEN">الإجابة باللغة الانجليزية</label>
										<Controller
											name="answer.en"
											control={control}
											rules={{ required: true }}
											render={({ field }) => (
												<ReactQuill
													{...field}
													id="faqEN"
													theme="snow"
													modules={quillModules}
													formats={quillFormats}
												/>
											)}
										/>
										{errors.answer?.en && (
											<small className="text-danger">هذا الحقل مطلوب</small>
										)}
									</div>
								</Col>
							</Row>

							<Row>
								<Col>
									<div className="form-item mt-3">
										<button type="submit" className="bt bt-success btn-block">
											إرسال
										</button>
									</div>
								</Col>
							</Row>
						</div>
					</div>
				</form>
			</Container>
		</section>
	);
};

export default FaqsCreate;
